export const TASK_PRIORITY: Record<string, number> = {
  // System tasks that need to run before anything else, such as initialization tasks. Should be used sparingly.
  HIGHEST: 1,

  // Tasks that are important but can wait until after the initial critical tasks have run, such as tracker initialization.
  HIGH: 10,

  // default priority for tasks in TaskQueue
  MID: 100,

  // Tasks that are not time-sensitive and can be executed after all higher priority tasks have been processed
  LOW: 1000,
} as const;
